import { FC } from 'react';
import { RosterTier } from './roster-tier';
import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { CheckedIcon } from '@wwe-portal/ui/components/icons/checked-icon';
import { tryFormatThousands } from '@wwe-portal/utils/format';
import { RosterPlaylist } from '../roster-playlist';

interface RosterCardBackProps {
  superstarId: string | undefined;
  name: string;
  tier: string | undefined;
  talentScore: number | undefined;
  totalUpgrades: number | undefined;
  LinkComponent?: React.ComponentType<{
    superstarId: string;
    children: React.ReactNode;
  }>;
  videoLinks?: {
    image: string;
    link: string;
  }[];
}

export const RosterCardBack: FC<RosterCardBackProps> = ({
  superstarId,
  name,
  videoLinks,
  tier,
  talentScore,
  totalUpgrades,
  LinkComponent,
}) => {
  const cta = (
    <ClickableDiv
      className="rounded-10 flex items-center justify-center py-1"
      style={{
        background:
          'linear-gradient(180deg, #FFD000 0%, #FFA500 7.5%, #CD7F32 21.5%, #D2691E 58%, #CD7F32 87.5%)',
      }}
    >
      <span className="drop-shadow-text stroke-1 text-xs font-bold">
        DETAILS
      </span>
    </ClickableDiv>
  );
  return (
    <div className="rounded-10 bg-back400 h-full w-full px-3 pt-4 italic">
      <div
        className="bg-back300 h-9 w-full"
        style={{
          filter: 'drop-shadow(0px 1px 3px rgba(0, 186, 255, 0.86))',
        }}
      >
        <div className="bg-plastic flex h-full items-center justify-center truncate px-2 font-bold uppercase">
          <span className="drop-shadow-fx w-full truncate px-2 text-center text-[#F5A200]">
            {name}
          </span>
        </div>
      </div>
      {tier ? (
        <div className="px-6">
          <RosterTier tier={tier} size="long" ratio={140 / 20} />
        </div>
      ) : null}
      <div className="mt-3 w-full" style={{ height: 120 }}>
        <RosterPlaylist videoLinks={videoLinks} />
      </div>
      <div className="mt-3 truncate pl-3 text-xs">
        <span className="text-text400">Talent Score: </span>
        <span className="text-white">{talentScore}</span>
        <CheckedIcon className="text-green600 ml-1 inline-block h-2 w-2" />
      </div>
      <div className="mt-1 truncate pl-3 text-xs">
        <span className="text-text400">Total Upgrades: </span>
        <span className="text-white">
          {tryFormatThousands(totalUpgrades, '???')}
        </span>
        <CheckedIcon className="text-green600 ml-1 inline-block h-2 w-2" />
      </div>
      <div className="mt-6">
        {LinkComponent && superstarId != null ? (
          <LinkComponent superstarId={superstarId}>{cta}</LinkComponent>
        ) : (
          cta
        )}
      </div>
      <div className="mt-3 border-t border-t-white/20" />
    </div>
  );
};
